import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import makeStyles from '@material-ui/core/styles/makeStyles';
import './assets/css/index.css';
import App from './App';
import store from './app/store';
import * as serviceWorkerRegistration from './serviceWorker';
import Loading from './components/Loading';

const useStyles = makeStyles(
  () => ({
    root: {
      zIndex: 7000,
    },
    containerAnchorOriginTopLeft: {
      left: 24,
    },
  }),
  {
    name: 'SnackbarRoot',
  },
);

function Index() {
  const classes = useStyles();
  return (
    <Suspense fallback={<Loading />}>
      <Provider store={store}>
        <Router>
          <SnackbarProvider
            classes={{
              containerRoot: classes.root,
              containerAnchorOriginTopLeft:
                classes.containerAnchorOriginTopLeft,
            }}
            maxSnack={5}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <App />
          </SnackbarProvider>
        </Router>
      </Provider>
    </Suspense>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));

serviceWorkerRegistration.register({
  onUpdate: reg => {
    try {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('error', error);
    }
  },
});
